<template>
  <div v-if="product.cartItemOptions && product.cartItemOptions.length > 0" class="mt-2 px-2">
    <p class="text-size-small mb-0"><i class="fas fa-shopping-cart mr-1 text-secondary"></i> In your cart</p>
      <div class="d-flex flex-wrap variation-in-cart">
        <template v-for="option in options" :key="option.product.id">
          <p class="badge badge-secondary text-white pt-1 mr-2 px-2 my-1 cursor-pointer" @click="itemClicked(option)">
            {{option.linked_qty}} {{ option.product.name.replace(product.name, '').replace('-', '') }}
          </p>
        </template>
      </div>

      <p v-if="product.cartItemOptions.length > 5 && !isSingle" class="mb-0 text-secondary">
        <i class="fas fa-plus fa-sm"></i> {{product.cartItemOptions.length - 5}} more...
      </p>
  </div>
</template>

<script>
  export default {
    props: {
      product: Object,
      productLink: String,
      cart_items: Array,
      isSingle: Boolean
    },
    mounted() {
      this.getCartItems()
    },
    computed: {
      options() {
        return this.isSingle ? this.product.cartItemOptions : this.product.cartItemOptions.slice(0,5)
      }
    },
    methods: {
      getCartItems() {
        this.product.cartItemOptions = []
        this.cart_items.forEach(item => {
          if (item.variation_product_id === this.product.id) {
            this.product.cartItemOptions.push(item)
          }
        })
      },
      itemClicked(option) {
        if (this.product.attributes && this.product.attributes.length !== 1 && !this.isSingle) {
          this.$inertia.visit(this.route(this.productLink, this.product.id))
        }
        else {
          this.$emit('fillOption', this.product, option.product.id, option)
        }
      }
    }
  }
</script>
